export default [
    {
        path: "/maintenance",
        name: "maintenance",
        component: () => import("../../views/utility/maintenance"),
    }
];
